import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClipsSignupComponent } from './clips-signup.component';

const routes: Routes = [
  {
    path: 'signup/clips',
    component: ClipsSignupComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClipsSignupRoutingModule { }
